import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Info } from '@bibliocommons/base-icons';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';

import Popover from 'app/components/shared/Popover';

import './BroadenSearchInfoPopOver.scss';

function renderContent() {
  return (
    <div className="pop-over-content">
      <div className="prompt-heading-block">
        <FormattedMessage id="broaden_search_info_heading" />
      </div>
      <FormattedMessage id="broaden_search_info_desc" />
    </div>
  );
}

function renderTriggerContent() {
  return (
    <div>
      <ScreenReaderMessage>
        <FormattedMessage id="ada_broaden_search_info" />
      </ScreenReaderMessage>
      <button className="pop-over-trigger" type="button">
        <Info />
        <span aria-hidden="true">
          <FormattedMessage id="more_details" />
        </span>
      </button>
    </div>
  );
}

export default function BroadenSearchInfoPopOver() {
  return (
    <span className="cp-broaden-search-info-warning">
      <Popover dataKey="broaden-search-info-warning-pop-over" renderContent={renderContent} triggerOnHover={false}>
        {renderTriggerContent()}
      </Popover>
    </span>
  );
}
